import React from 'react';
import { FaFilm, FaMapMarkerAlt, FaPhotoVideo, FaUndo } from 'react-icons/fa';

// import required modules

import styles from './Botoes.module.css';
import Compartilhar from './Compartilhar';

const Botoes: React.FC<{
    site: any;
    detailsProperties: any;
    setOpenMapa?: any;
    setOpenStreet?: any;
    setOpenOption?: any;
    openOption?: any;
    favorito?: any;
    setFavorito?: any;
}> = ({
    site,
    detailsProperties,
    setOpenMapa,
    setOpenStreet,
    setOpenOption,
    openOption,
    favorito,
    setFavorito
}) => {
    // useState
    const total_fotos: number= detailsProperties?.usa_fotos_empreendimento ? detailsProperties?.empreendimento?.fotos?.length || 0 : 0+detailsProperties?.fotos?.length || 0;
 
    return (
        <div className={styles.full}>
            <ul className={styles.baloes}>
                <li key={"fotos"}>
                    <button onClick={() => setOpenOption(1)} className={openOption == 1 ? styles.selecionado : styles.balao} 
                        style={site?.cor2 != "#ffffff" && openOption == 1 ? {backgroundColor: site?.cor2} : {}}>
                        <FaPhotoVideo className={styles.icon_balao} />{total_fotos} Fotos
                    </button>
                </li>
                {detailsProperties?.latitude_longitude && site?.mostrar_mapa ? <li key={"mapa"}><button className={openOption == 2 ? styles.selecionado : styles.balao} style={site?.cor2 != "#ffffff" && openOption == 2 ? {backgroundColor: site?.cor2} : {}} onClick={() => {setOpenOption(0);setOpenMapa(1)}}><FaMapMarkerAlt  className={styles.icon_balao} />Mapa</button></li> : null}
                {detailsProperties?.latitude_longitude && site?.mostrar_mapa ? <li key={"mapaStreet"}><button className={openOption == 5 ? styles.selecionado : styles.balao} style={site?.cor2 != "#ffffff" && openOption == 2 ? {backgroundColor: site?.cor2} : {}} onClick={() => {setOpenOption(0);setOpenStreet(1)}}><FaMapMarkerAlt  className={styles.icon_balao} />StreetView</button></li> : null}
                {detailsProperties?.link_video && ((detailsProperties?.link_video != 'https://youtu.be/EngkU-Vcp2Q' && detailsProperties?.link_video != "https://www.youtube.com/watch?v=EngkU-Vcp2Q&feature=youtu.be") || site?.id != '2059') ? <li key={"video"}><button style={site?.cor2 != "#ffffff" && openOption == 3 ? {backgroundColor: site?.cor2} : {}} onClick={() => setOpenOption(3)} className={openOption == 3 ? styles.selecionado : styles.balao}><FaFilm  className={styles.icon_balao} />Vídeo</button></li> : null}
                {detailsProperties?.tour360 ? <li key={"trou360"}><button className={openOption == 4 ? styles.selecionado : styles.balao} style={site?.cor2 != "#ffffff" && openOption == 4 ? {backgroundColor: site?.cor2} : {}} onClick={() => setOpenOption(4)}><FaUndo  className={styles.icon_balao} />Tour 360</button></li> : null}
            </ul>
            {openOption >= 1 && openOption != 2 ? <Compartilhar favorito={favorito} detailsProperties={detailsProperties}></Compartilhar>: null}
        </div>
    );
};

export default Botoes;
